import { IFCWithChildren } from '~/interfaces/i-fc-with-children';

import { MenuProvider } from './menu';

export const LeapProviders: IFCWithChildren = ({ children }) => (
  <MenuProvider>{children}</MenuProvider>
);
